module.exports = __webpack_public_path__ + "static/p-kembali-ke-indonesia-558a4cd18cb292140845cb881f850771.jpg";